export const RECEPCAO = () => `/recepcao`;
